import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import Table from "../Theme/Table.js";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Badge from "@mui/material/Badge";
import { useContext } from "react";
import { RoleContext } from "../RoleContext";
import Spinner from "../Spinner";
import { Button } from "react-bootstrap";
import { Checkbox, Modal } from "antd";
import { handleExportClick } from "../exportFile.js";
const SharedTripsList = () => {
  const roleData = useContext(RoleContext);
  var role = JSON.parse(roleData);
  let [loading, setLoading] = useState(true);
  const [trips, setTrips] = useState([]);

  const getTrips = async () => {
    const response = await axios
      .get("sharedTrips/")
      .then((res) => {
        const tripsWithMergedNames = res.data.map((transaction) => {
          const passengerName = `${transaction.passenger?.firstName} ${transaction.passenger?.lastName}`;
          const driverName = `${transaction.driver?.firstName} ${transaction.driver?.lastName}`;

          return {
            ...transaction,
            passenger: { ...transaction.passenger, name: passengerName },
            driver: { ...transaction.driver, name: driverName },
          };
        });

        setTrips(tripsWithMergedNames);
        setLoading(false);
        //notify()
      })
      .catch((err) => {
        notifyError();
      });
  };
  const edit = "trip";
  const detail = "viewTrip";

  const notify = () =>
    toast.success("Trips list loaded.", {
      position: "top-right",
      autoClose: 1000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });

  const notifyError = () =>
    toast.error("Something went wrong ...", {
      position: "top-right",
      autoClose: 1000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  useEffect(() => {
    getTrips();
  }, []);
  const columns = React.useMemo(
    () => [
      {
        Header: "Trip Owner",
        columns: [
          {
            Header: "ID",
            accessor: "id",
          },
          {
            Header: "First Name",
            accessor: "passenger.firstName",
          },
          {
            Header: "Last Name",
            accessor: "passenger.lastName",
          },
          {
            Header: "Phone Number",
            accessor: "passenger.phoneNumber",
          },
        ],
      },
      {
        Header: "Driver Information",
        columns: [
          {
            Header: "First Name",
            accessor: "driver.firstName",
          },
          {
            Header: "Last Name",
            accessor: "driver.lastName",
          },
          {
            Header: "Phone Number",
            accessor: "driver.phoneNumber",
          },

          {
            Header: "Status",
            accessor: "status",
            disableFilters: true,

            Cell: (row) => (
              <div>
                <Badge
                  badgeContent={row.cell.row.original.status}
                  color="warning"
                >
                  {" "}
                </Badge>
              </div>
            ),
          },

          {
            Header: "Action",
            accessor: "action",
            disableFilters: true,
            Cell: (row) => (
              <div>
                {role.filter(function (e) {
                  return e.perm_name === "list_shared_trips";
                }).length > 0 && (
                  <Link
                    to={
                      "/" +
                      "sharedTripDetail" +
                      "/" +
                      row.cell.row.original.tripId
                    }
                  >
                    <i className="fas fa-eye success" />
                  </Link>
                )}
              </div>
            ),
          },
        ],
      },
    ],
    []
  );

  const columns_expo = React.useMemo(
    () =>
      [
        {
          columns: [
            {
              Header: "Id",
              accessor: "id",
            },
          ],
        },
        {
          Header: "Passenger",
          columns: [
            { Header: "Passenger Name", accessor: "passenger.name" },
            // { Header: "Last Name", accessor: "passenger.lastName" },
            { Header: "Passenger Phone", accessor: "passenger.phoneNumber" },
          ],
        },
        {
          Header: "Driver",
          columns: [
            { Header: "Driver Name", accessor: "driver.name" },
            // { Header: "Last Name", accessor: "driver.lastName" },
            { Header: "Driver Phone", accessor: "driver.phoneNumber" },
          ],
        },
        {
          Header: "Other",
          columns: [
            { Header: "Date", accessor: "createdAt" },
            {
              Header: "Status",
              accessor: "status",
            },
          ],
        },
      ].flatMap((group) => group.columns),
    []
  );
  const [isModalVisible, setIsModalVisible] = useState(false);

  const showModal = () => {
    setIsModalVisible(true);
  };

  const [selectedColumns, setSelectedColumns] = useState(
    columns_expo.map((column) => column.Header)
  );

  const handleOkModal = () => {
    console.log("handleOkModal called");
    setIsModalVisible(false);
    handleExportClick(
      trips,
      columns_expo,
      "Shared Trips",
      "shared_trips.pdf",
      selectedColumns
    );
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };
  // Inside your component
  function handleColumnToggle(columnHeader) {
    setSelectedColumns((prevSelectedColumns) => {
      if (prevSelectedColumns.includes(columnHeader)) {
        return prevSelectedColumns.filter((col) => col !== columnHeader);
      } else {
        return [...prevSelectedColumns, columnHeader];
      }
    });
  }

  return (
    <div className="content-wrappers">
      <br />
      <br />
      <ToastContainer />

      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-header">
                  <h3
                    className="card-title"
                    style={{ marginRight: 850 + "px" }}
                  >
                    Shared Trips
                  </h3>
                  <Button onClick={showModal} className="btn btn-success bt">
                    Export
                  </Button>
                  <Modal
                   style={{marginTop: "60px"}} 
                    title="Select Columns to Export"
                    visible={isModalVisible}
                    onOk={handleOkModal}
                    onCancel={handleCancel}
                    footer={[
                      <Button key="cancel" onClick={handleCancel}>
                        Cancel
                      </Button>,
                      <Button
                        style={{ marginLeft: "10px" }}
                        key="ok"
                        type="primary"
                        onClick={handleOkModal}
                      >
                        OK
                      </Button>,
                    ]}
                  >
                    <div style={{ marginBottom: "20px" }}>
                      {columns_expo.map((column) => (
                        <div
                          key={column.Header}
                          style={{ marginBottom: "10px" }}
                        >
                          <Checkbox
                            checked={selectedColumns.includes(column.Header)}
                            onChange={() => handleColumnToggle(column.Header)}
                            style={{ marginRight: "10px", fontSize: "16px" }}
                          >
                            {column.Header}
                          </Checkbox>
                        </div>
                      ))}
                    </div>
                  </Modal>
                </div>

                <div className="card-body">
                  {loading && (
                    <div>
                      <Spinner />
                    </div>
                  )}
                  {!loading && (
                    <Table
                      columns={columns}
                      data={trips}
                      edit={edit}
                      detail={detail}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};
export default SharedTripsList;
